import { EMAIL_TEMPLATES } from "../constants/api";
import { utils_api } from "../utils/utils_api";

export const api_email_templates = {
  get_all(success, fail) {
    return utils_api.auth_get(EMAIL_TEMPLATES.GET, success, fail);
  },
  save_draft(data, success, fail) {
    return utils_api.auth_put(EMAIL_TEMPLATES.PUT, data, success, fail);
  },
  publish(data, success, fail) {
    return utils_api.auth_post(EMAIL_TEMPLATES.PUBLISH, data, success, fail);
  },
  discard_draft(data, success, fail) {
    return utils_api.auth_delete(EMAIL_TEMPLATES.DRAFT, data, success, fail);
  },
  get_brevo_templates(success, fail) {
    return utils_api.auth_get(EMAIL_TEMPLATES.BREVO_GET, success, fail);
  },
  refresh_brevo_templates(success, fail) {
    return utils_api.auth_get(
      EMAIL_TEMPLATES.BREVO_GET + "?refresh=true",
      success,
      fail,
    );
  },
  send_test(data, success, fail) {
    return utils_api.auth_post(EMAIL_TEMPLATES.TEST_POST, data, success, fail);
  },
};
